import React from "react"
import './styles.css'

export const LoadSpinner = () => {

  return (
    <div className="loading-spinner-container">
      <div className="spinner-border text-dark loading-spinner" role={false}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )
}